import { SurveyQuestionType } from "constants/enums/StudentSurveyEnum";
import React from "react";
import FileDetail from "./FileDetail";

const SurveyQuestionOption = ({
  letter,
  question,
  option,
  answer,
  answerSetter,
  selectedPersonnel
}) => {
  const checkOptionSelected = () => {
    const isSelected = answer
      .filter((_answer) => _answer?.taggedId === selectedPersonnel?.taggedId)
      .filter((_answer) => _answer?.branchInfo?.id === selectedPersonnel?.branch)
      .find((_question) => _question?.questionId === question?.id);
    if (isSelected && isSelected?.optionId === option?.id) {
      return true;
    }
    return false;
  };

  return (
    <div
      onClick={() => answerSetter(question, option, SurveyQuestionType.MULTI_SELECT)}
      className={"rounded border d-flex px-4 align-items-center mb-2 py-2 cursor-pointer"}
      style={{
        background: checkOptionSelected() ? "#99D490" : "white",
        color: checkOptionSelected() && "white"
      }}
    >
      <div className={"mr-2"}>{letter} - </div>
      <div>
        {option?.fileHash && <FileDetail sha={option?.fileHash} />}
        {option?.optionText}
      </div>
    </div>
  );
};

export default SurveyQuestionOption;
